import { useLocation } from "react-router-dom";

function formatBreadcrumbName(name: string): string {
  // if link = packing-list then Packing List
  return name
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
}

export function useBreadcrumbs() {
  const location = useLocation();
  const paths = location.pathname.split("/").filter((path) => path !== "");

  const breadcrumbs = paths.map((path, index) => ({
    name: formatBreadcrumbName(path),
    to: `/${paths.slice(0, index + 1).join("/")}`, // Create the full path
    isLast: index === paths.length - 1, // Determine if it's the last breadcrumb
  }));

  return { breadcrumbs };
}
